<template>
  <div class="join-page">
    <div class="join-main">
      <!-- 背景图：复用关于我们模块一的背景（about-1-company.png），absolute 铺满 cover 裁切 -->
      <img class="join-bg" src="../assets/images/about/about-1-company.png" alt="" />
      <div class="join-content">
        <button class="join-back-btn" @click="goBack">{{ $t('join.back') }}</button>
        <h1 class="join-title">{{ $t('join.hotJobs') }}</h1>
        <!-- 岗位卡片：左侧岗位名，右侧立即投递按钮 -->
        <div class="join-list">
          <div v-for="job in jobs" :key="job.id" class="job-card">
            <span class="job-name">{{ $t('join.jobs.' + job.id) }}</span>
            <button class="job-apply-btn" @click="apply(job.id)">{{ $t('join.applyNow') }}</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'JoinPage',
  components: { Footer },
  data() {
    return {
      // 热招岗位列表：岗位名走 i18n（join.jobs.岗位id），新增岗位在这里加一条即可
      jobs: [
        { id: 'register' },
        { id: 'backend' },
        { id: 'tester' },
        { id: 'sales' },
        { id: 'trade' },
        { id: 'regSpecialist' },
        { id: 'embedded' }
      ]
    }
  },
  methods: {
    // 点"立即投递"：带岗位 id 跳投递表单页
    apply(id) {
      this.$router.push('/join/apply?job=' + id)
    },
    // 点"返回"：跳关于我们页模块一（页面顶部）
    goBack() {
      this.$router.push('/about')
    }
  },
  watch: {
    // 切换到英文版时自动跳回关于我们页（英文版隐藏"加入我们"入口）
    '$i18n.locale'(val) {
      if (val === 'en') {
        this.$router.replace('/about')
      }
    }
  }
}
</script>

<style scoped>
.join-page {
  padding-top: 80px;
}

/* 页面主体：背景图定位基准 */
.join-main {
  position: relative;
  min-height: calc(100vh - 80px);
}

/* 背景图：与关于我们模块一一致，铺满主体区域、cover 裁切 */
.join-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 内容区：限宽居中，叠在背景图上方 */
.join-content {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 50px 40px 140px;
}

/* 返回按钮（改 font-size 调大小） */
.join-back-btn {
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease;
}

.join-back-btn:hover {
  opacity: 0.7;
}

/* 页面标题“热招岗位”：改 font-size 调大小，下划线与 JobApply 页面包屑水平对齐 */
.join-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 20px 0;
  position: relative;
}

/* 标题下划线：纯白不透明，改 width 调长度，改 bottom 调与文字间距 */
.join-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 11.8%;
  height: 2px;
  background: #FFFFFF;
}

/* 仅英文生效：页面标题单独调字号 */
:lang(en) .join-title {
  font-size: 42px;
}

/* 岗位卡片：灰色圆角条，名称居左、按钮居右（改 height 调卡片高度） */
.job-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(240, 240, 240, 0.5);
  border-radius: 10px;
  height: 80px;
  padding: 0 44px;
  margin-bottom: 16px;
}

.job-name {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
}

/* 仅英文生效：岗位名单独调字号 */
:lang(en) .job-name {
  font-size: 24px;
}

/* 立即投递按钮（改 background 调按钮颜色） */
.job-apply-btn {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 12px 36px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease;
}

/* 仅英文生效：投递按钮单独调字号 */
:lang(en) .job-apply-btn {
  font-size: 18px;
}

.job-apply-btn:hover {
  background: #00C4D4;
}




/* ============================================================
 * 移动端适配（<= 1024px）
 * ============================================================ */
@media (max-width: 1024px) {
  /* 页面容器：不设顶部留白，让背景图铺满视口 */
  .join-page {
    padding-top: 0;
  }

  /* 主内容区：铺满整屏，背景图覆盖整个区域 */
  .join-main {
    min-height: 100vh;
  }

  /* 内容内边距：顶部预留导航栏高度，内容从导航栏下方开始 */
  .join-content {
    padding: 14vh 6% 20vh;
  }

  /* 返回按钮：字号收窄，位置上移 */
  .join-back-btn {
    font-size: 4.27vw;
    transform: translateY(-3vh);
  }

  /* 页面大标题 */
  .join-title {
    font-size: 8vw;
    margin: 0 0 3vh 0;
  }

  /* 标题下划线 */
  .join-title::after {
    bottom: -1vh;
    height: 0.4vh;
    width: 24vw;
  }

  :lang(en) .join-title {
    font-size: 9vw;
  }

  /* 岗位卡片：固定高度 + 圆角 */
  .job-card {
    height: 9vh;
    padding: 0 6%;
    margin-bottom: 2vh;
    border-radius: 2vw;
  }

  /* 岗位名称 */
  .job-name {
    font-size: 5vw;
  }

  :lang(en) .job-name {
    font-size: 4.5vw;
  }

  /* 投递按钮 */
  .job-apply-btn {
    padding: 1.5vh 5vw;
    font-size: 4vw;
    border-radius: 2vw;
  }

  :lang(en) .job-apply-btn {
    font-size: 3.5vw;
  }
}
</style>
